import { render, staticRenderFns } from "./ConsumptionReportWidgetComponent.vue?vue&type=template&id=23b67a08&scoped=true&"
import script from "./ConsumptionReportWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ConsumptionReportWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConsumptionReportWidgetComponent.vue?vue&type=style&index=0&id=23b67a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b67a08",
  null
  
)

export default component.exports